export const initialInvoices = [
  {
    id: 'INV-0001',
    num: 'INV-0001',
    customer: 'Andreas Demetriou',
    email: 'andreas@email.com',
    addr: 'Paphos, Cyprus',
    vehicle: 'TAXI – MZZ099',
    contract: 'CNT-001',
    vid: 'mzz099',
    method: 'stripe',
    methodLabel: 'Stripe · Card',
    issue: '14 Jan 2026',
    due: '20 Jan 2026',
    issueDate: '2026-01-14',
    dueDate: '2026-01-20',
    lines: [{ desc: 'Vehicle rental — TAXI MZZ099 (5 days)', qty: 5, unit: 13, total: 65 }],
    subtotal: 65,
    vatRate: 19,
    vatAmt: 12.35,
    discount: 0,
    discType: 'eur',
    total: 77.35,
    notes: 'Thank you for your business!',
    status: 'paid',
    source: 'manual',
  },
  {
    id: 'INV-0002',
    num: 'INV-0002',
    customer: 'BuildCo Ltd',
    email: 'admin@buildco.cy',
    addr: 'Limassol, Cyprus',
    vehicle: 'MINIBUS – KLM147',
    contract: 'CNT-002',
    vid: 'klm147',
    method: 'cash',
    methodLabel: 'Cash',
    issue: '18 Feb 2026',
    due: '24 Feb 2026',
    issueDate: '2026-02-18',
    dueDate: '2026-02-24',
    lines: [{ desc: 'Vehicle rental — MINIBUS KLM147 (4 days)', qty: 4, unit: 80, total: 320 }],
    subtotal: 320,
    vatRate: 19,
    vatAmt: 60.8,
    discount: 0,
    discType: 'eur',
    total: 380.8,
    notes: 'Payment due on vehicle return.',
    status: 'overdue',
    source: 'manual',
  },
  {
    id: 'INV-0003',
    num: 'INV-0003',
    customer: 'Stavros Builders',
    email: 'stavros@builders.cy',
    addr: 'Paphos, Cyprus',
    vehicle: 'MINI EXCAVATOR – NAH532',
    contract: 'CNT-003',
    vid: 'nah532',
    method: 'bank',
    methodLabel: 'Bank Transfer',
    issue: '01 Mar 2026',
    due: '18 Mar 2026',
    issueDate: '2026-03-01',
    dueDate: '2026-03-18',
    lines: [
      { desc: 'Equipment rental — MINI EXCAVATOR NAH532 (4 days)', qty: 4, unit: 120, total: 480 },
      { desc: 'Operator fee', qty: 4, unit: 50, total: 200 },
    ],
    subtotal: 680,
    vatRate: 19,
    vatAmt: 129.2,
    discount: 50,
    discType: 'eur',
    total: 759.2,
    notes: 'Bank transfer due before rental start.',
    status: 'pending',
    source: 'manual',
  },
  {
    id: 'INV-0004',
    num: 'INV-0004',
    customer: 'Maria Kyriakidou',
    email: 'maria@email.com',
    addr: 'Nicosia, Cyprus',
    vehicle: 'MINIBUS – KLM147',
    contract: 'RH-003',
    vid: 'klm147',
    method: 'stripe',
    methodLabel: 'Stripe · Card',
    issue: '01 Mar 2026',
    due: '04 Mar 2026',
    issueDate: '2026-03-01',
    dueDate: '2026-03-04',
    lines: [
      { desc: 'Vehicle rental — MINIBUS KLM147 (3 days)', qty: 3, unit: 80, total: 240 },
      { desc: 'Damage charge — dent on left door', qty: 1, unit: 200, total: 200 },
    ],
    subtotal: 440,
    vatRate: 19,
    vatAmt: 83.6,
    discount: 0,
    discType: 'eur',
    total: 523.6,
    notes: 'Damage charge applied. Deposit partially withheld.',
    status: 'paid',
    source: 'manual',
  },
  {
    id: 'INV-0005',
    num: 'INV-0005',
    customer: 'Online Customer',
    email: 'stavros.andreou@email.com',
    addr: 'Paphos, Cyprus',
    vehicle: 'FORD TRANSIT – NXT987',
    contract: 'BK-2026-0047',
    vid: 'nxt987',
    method: 'online',
    methodLabel: 'Online (pre-paid)',
    issue: '14 Mar 2026',
    due: '16 Mar 2026',
    issueDate: '2026-03-14',
    dueDate: '2026-03-16',
    lines: [{ desc: 'Vehicle rental — FORD TRANSIT NXT987 (5 days)', qty: 5, unit: 65, total: 325 }],
    subtotal: 325,
    vatRate: 19,
    vatAmt: 61.75,
    discount: 0,
    discType: 'eur',
    total: 386.75,
    notes: 'Pre-paid online via booking page. Ref: BK-2026-0047.',
    status: 'paid',
    source: 'online',
  },
];

export const invStatusStyle = {
  paid: { bg: 'var(--gr-l)', bd: 'var(--gr-b)', tx: 'var(--gr)', label: 'Paid' },
  pending: { bg: 'var(--am-l)', bd: 'var(--am-b)', tx: 'var(--am)', label: 'Pending' },
  issued: { bg: 'var(--bl-l)', bd: 'var(--bl-b)', tx: 'var(--bl)', label: 'Issued' },
  overdue: { bg: 'var(--ac-l)', bd: 'var(--ac-b)', tx: 'var(--ac)', label: 'Overdue' },
  cancelled: { bg: 'var(--sur2)', bd: 'var(--bd2)', tx: 'var(--tx3)', label: 'Cancelled' },
  draft: { bg: '#f0f0f0', bd: '#ccc', tx: '#888', label: 'Draft' },
};

export const methodIcon = { cash: '💵', stripe: '💳', bank: '🏦', online: '🌐' };
